import { render } from "./CompareCoverageModal.vue?vue&type=template&id=e2463e4e&scoped=true"
import script from "./CompareCoverageModal.vue?vue&type=script&lang=js"
export * from "./CompareCoverageModal.vue?vue&type=script&lang=js"

import "./CompareCoverageModal.vue?vue&type=style&index=0&id=e2463e4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2463e4e"]])

export default __exports__